import React from 'react';
import { Chart } from 'react-google-charts';
import { useSelector } from "react-redux";

const GeoChart = () => {
  const { dashboardData } = useSelector((state) => state.DashboardSlice);

  // 1. Prepare header
  const chartHeader = ['Country', 'Members'];

  // 2. Convert geo_chart_data to chart-compatible array
  const chartRows =
    Array.isArray(dashboardData?.geo_chart_data)
      ? dashboardData.geo_chart_data.map((item) => [
          item.country,
          item.members,
        ])
      : [];

  const data = [chartHeader, ...chartRows];

  const options = {
    colorAxis: { colors: ['#F1C40F', '#2980B9'] },
    backgroundColor: '#ffffff',
    datalessRegionColor: '#f0f0f0',
    defaultColor: '#f5f5f5',
  };

  return (
    <div className="form-group col-md-12 mt-4 ">
      <Chart
        chartType="GeoChart"
        width="100%"
        height="500px"
        className='rounded'
        data={data}
        options={options}
      />
    </div>
  );
};

export default GeoChart;
